/* eslint-disable require-jsdoc */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { deleteUrlParams } from '../../../../utils/url';


const popUp = (props) => {
  const handleChange = () => {
    props.onChange(false);
    const sharelinkData=false;
    window.eraseShareLinkData(!sharelinkData);
    deleteUrlParams();
  };
  const modalClass = `hearby-cw-theme-light`;
  return (
    <div>
      <Modal className={modalClass}
        enforceFocus={false}
        dialogClassName='hearby-carousel-detail-popup'
        size="lg"
        show={props.openOrNot}
        onHide={handleChange}
        backdrop={true}
        keyboard={false}
        scrollable={true}
        animation={false}
      >

        <Modal.Body>
          <div className="text-right">
            <Button
              variant="secondary"
              onClick={handleChange}
            >
              x
            </Button>
          </div>
          {props.children}
        </Modal.Body>

      </Modal>
    </div>
  );
};

export default popUp;
